import cx from "classnames";

import AppImage from "components/AppImage";

import styles from "./LandingPageCover.module.scss";

interface LandingPageCoverProps {
  src: string;
  className: string;
}
const LandingPageCover = ({ src, className }: LandingPageCoverProps) => {
  return (
    <div className={cx(styles.cover, className)}>
      <AppImage alt="" src={src} className={styles.img} />
    </div>
  );
};

export default LandingPageCover;
